<div class="print-item-section" style="margin-top: 0">

  <div style="margin-bottom: 2em" *ngIf="!print"><button class="nrk-button" (click)="copyTCOverviewToClipboard()">Copy TC Overview to Clipboard</button></div>
  <div style="margin-bottom: 2em" *ngIf="!print"><button class="nrk-button" (click)="saveAllPFSPOs()">Save all PFSPO</button></div>
  <div style="margin-bottom: 1em" *ngIf="!print"><button class="nrk-button" (click)="sortLineItems(1)">Sort Line Items by Customer Reference A-Z</button></div>
  <div style="margin-bottom: 1em" *ngIf="!print"><button class="nrk-button" (click)="sortLineItems(2)">Sort Line Items by SPO Number Low to High</button></div>
  <div style="margin-bottom: 1em" *ngIf="!print"><button class="nrk-button" (click)="sortLineItems(3)">Sort Line Items by CRDD</button></div>

  <ng-container *ngIf="!compilation.shipmentLineItems.length">
    <div style="padding-bottom:0.5em;font-weight:bold">Shipment Line Items</div>
    <div class="print-item print-item-header">
      <table class="doc-header" style="color:black">
        <tr>
          <td>
            <div style="position:relative;bottom:5px"><div style="position:absolute">
              <ngx-document-spo-selector *ngIf="!disabled && !print"
                title="Add (PF)SPO" [abstractItem]="this.compilation" 
                [latestVersionItems]="latestVersionItems"
                (compilationChange)="addItem($event)"
              ></ngx-document-spo-selector>
            </div></div>
          </td>
          <td>Document number</td>
          <td>Date</td>
          <td>Customer</td>
          <td>Customer reference</td>
          <td>Status</td>
        </tr>
      </table>
    </div>
  </ng-container>   

  <ng-container *ngFor="let item of compilation.shipmentLineItems; index as idx; last as isLast">

    <div class="print-item-non-breakable">

      <ng-container *ngIf="idx === 0">

        <div *ngIf="!disabled" style="position:relative"><div style="position:absolute;right:0;top:-0.5em;">
          <button class="nrk-button mr-3" (click)="setSposCompleted()" *ngIf="this.compilation.transportRun?.transportStatus === 3">
            Set all (PF)SPO's status to completed
          </button>
          <button class="nrk-button" (click)="compilation.hidePricing = !compilation.hidePricing">
            hide pricing {{compilation.hidePricing ? '✓' : ''}}
          </button>
        </div></div>

        <div style="padding-bottom:0.5em;font-weight:bold">Shipment Line Items</div>
        <div class="print-item print-item-header">
          <table class="doc-header" style="color:black">
            <tr>
              <td>
                <div style="position:relative;bottom:5px"><div style="position:absolute">
                  <ngx-document-spo-selector *ngIf="!disabled !print"
                    title="Add (PF)SPO" [abstractItem]="this.compilation" 
                    [latestVersionItems]="latestVersionItems"
                    (compilationChange)="addItem($event)"
                  ></ngx-document-spo-selector>
                </div></div>
              </td>
              <td [style.width]="disabled || print ? 0 : null"></td>
              <td>Document Number</td>
              <td>Issue Date</td>
              <td>Customer</td>
              <td>Customer Reference</td>
              <td>Status</td>
            </tr>
          </table>
        </div>
      </ng-container>   

      <div style="position:relative" *ngIf="item.document?.code" [ngClass]="print ?
        (idx %2 == 1 ? 'print-item print-item-odd' : 'print-item bg-white')
        : 
        (item.document?.transportRun?.spoStatus ? 'print-item table-success' : 'print-item table-warning')">
        <table class="doc-header">
          <tr>
            <td>{{idx+1}}</td>
            <td [style.width]="disabled || print ? 0 : null"><button *ngIf="!disabled && !print" class="nrk-doc-button" (click)="removeItem(idx)">-</button></td>
            <!-- <td class="pseudo-link" (click)="setDocument(item.document)">{{item.document | documentNumber : latestVersionItems}}</td> -->
            <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
              [queryParams]="{code: item.document.code}" target="_blank">{{item.document | documentNumber : latestVersionItems}}</a></td>
            <td>{{item.document?.issueDate | date : 'yyyy-MM-dd'}}</td>
            <td>{{getCustomerName(item.document)}}</td>
            <td>{{item.document?.customerDocumentNumber}}</td>
            <td>{{getSpoStatus(item.document)}}</td>
            <td *ngIf="!print">
              <!-- <div style="position:relative"><div style="position:absolute;width:7em;top:-0.87em">
                <span style="font-size:2rem" title="boxes present">{{hasLineItemBoxes(item) ? '☑':'☐'}}</span>
                <i style="cursor:pointer;font-size:2em;top:0.15em;position:relative" class="ionicon ion-upload h5 ml-2 mr-2" (click)="uploadTestCertificate(item)" title="Upload Test Certificate"></i>
                <span style="font-size:2rem" title="Test Certificate uploaded" *ngIf="item.document?.testCertificates?.length">✓</span> -->
                <div style="position:relative"><div style="position:absolute;width:6em;top:-0.87em">
                  TC: <i style="cursor:pointer;font-size:2em;top:0.15em;position:relative" class="ionicon ion-upload h5 ml-2 mr-2" (click)="uploadTestCertificate(item)" title="Upload Test Certificate"></i>
                  <span style="font-size:2rem" *ngIf="item.document?.testCertificates?.length">✓</span>
              </div></div>
            </td>

            <!-- <td *ngIf="!disabled" style="position:relative">
              <table  style="position:absolute;top:-0.5em;left:1em;">
                <tr>
                  <td *ngIf="idx == 0" class="moveItemDisabled">▲</td>
                  <td *ngIf="idx !== 0" class="moveItem" (click)="onMoveLineItem(idx, true)">▲</td>
                </tr>
                <tr>
                  <td *ngIf="isLast" class="moveItemDisabled">▼</td>
                  <td *ngIf="!isLast"class="moveItem" (click)="onMoveLineItem(idx, false)">▼</td>
                </tr>
              </table>
            </td> -->
          </tr>
        </table>
  
          <ng-container *ngFor="let li of item.document?.lineItems; index as lidx; last as lilast;">
            <table class="doc-line-item">
              <tr>
                <td><span *ngIf="!item.document.directDelivery && moment(item.document.vieDispatchDate).isBefore(moment(item.document.arrivingVieDate), 'day')" class="exclamation">!</span></td>
                <td><span>{{lidx+1}}</span></td>
                <td><label>ProductCode</label>{{li.finishedProduct?.calcCode}}; {{li.finishedProduct?.calcName}}</td>
                <td><label>Pieces</label>{{li.quantity}}</td>
                <td><label>m²</label>{{getSqm(li)}}</td>
                <td *ngIf="compilation.hidePricing"></td>
                <td *ngIf="!compilation.hidePricing"><label>Price/piece</label>{{li.piecePrice  | currency : item.document.currency : 'symbol' : '1.3-3' : 'de' }}</td>
                <td *ngIf="compilation.hidePricing"></td>
                <td *ngIf="!compilation.hidePricing"><label>Net sum</label>{{li.quantity * li.piecePrice   | currency : item.document.currency : 'symbol' : '1.2-2' : 'de' }}</td>
                <td><label>Net weight</label>{{getWeight(li) | number : '1.0-2' : 'de'}}&nbsp;{{$any(getWeight(li)) > 0 ? 'kg' : ''}}</td>
              </tr>
            </table>
            <div *ngIf="print" style="position:relative;text-align:right;right:1rem;height:0">
              <span class="small-text">Pallet Quantity:</span> {{$any(li).palletQty}}
            </div>
            <table class="doc-line-obic">
              <tr>
                <td></td><td></td>
                <td><label>OBIC</label>{{li.tbCode}}</td>
                <td *ngIf="!item.document.directDelivery"><label>VIE Dispatch Date</label>{{item.document.vieDispatchDate | date : 'yyyy-MM-dd'}}</td>
                <td *ngIf="item.document.directDelivery"><label>EXW Factory Date</label>{{item.document.exwJapanDate | date : 'yyyy-MM-dd'}}</td>
                <td><label>CRDD</label>{{item.document.customerRequestedDeliveryDate | date : 'yyyy-MM-dd'}}</td>
                <td></td>
                <td></td>
                <td *ngIf="!print" style="text-align:right;padding-top:1rem;padding-right:1.5rem">
                  <div style="display:inline-block;position:relative;bottom:0.4rem;right:1rem">Boxes: </div>
                  <div style="font-size:2em;display:inline-block">{{li.boxDetails?.length > 0 ? '☑':'☐'}}</div>
                  <div style="display:inline-block;position:relative;right:1.75rem" *ngIf="!disabled">
                    <button 
                      [nbPopover]="spoMover"
                      class="btn btn-sm btn-info"
                      style="position:absolute;margin: 0.5rem 0 !important;padding: 0.2rem 0.5rem !important"
                      title="move to another grouped shipment">
                      <i class="ion ion-arrow-swap"></i>
                    </button>
                    <ng-template #spoMover>
                      <div class="m-4">
                        Move PFSPO to GSNR:
                        <input type="text" class="form-control my-2" placeholder="Enter GSNR" [(ngModel)]="moveToGsnr"/>
                        <button class="btn btn-sm btn-primary" (click)="moveSpoToAnotherShipment(idx)">Move</button>
                      </div>
                    </ng-template>
                  </div>
                </td>
              </tr>
            </table>
            <table *ngIf="li.attributeRemark || li.attributeCode" style="margin-top:0.5em;">
              <tr>
                <td style="width:auto;padding-left:3.3em;text-align:left;"><span class="small-text">Customer product:</span>{{li.attributeRemark}}</td>
                <td style="width:auto;text-align:left"><span class="small-text">Customer code:</span>{{li.attributeCode}}</td>
              </tr>
            </table>
            <table *ngIf="!print" class="doc-line-packing">
              <tr>
                <td></td><td></td>
                <td>
                  <label>Factory order number:</label><input type="text" [(ngModel)]="li.factoryOrderNumber" placeholder="Factory order number" [attr.disabled]="disabled ? '' : null"/>
                </td>
                <td>
                  <label>Number of TC:</label><input type="text" [(ngModel)]="li.numberOfTC" placeholder="Number of TC" [attr.disabled]="disabled ? '' : null"/>
                </td>
                <td>
                  <label>Date of TC:</label><ngx-doc-form-date class="fullwidth" [(value)]="$any(li).dateOfTC" [disabled]="disabled"></ngx-doc-form-date>
                </td>
                <td>
                  <label>Date of prod:</label><ngx-doc-form-date class="fullwidth" [(value)]="$any(li).dateOfProduction" [disabled]="disabled"></ngx-doc-form-date>
                </td>
              </tr>
            </table>
            <div *ngIf="!print" style="position:relative;text-align:right;right:3rem;bottom:1rem;height:0">
              <span class="small-text">Pallet Quantity:</span> {{$any(li).palletQty}}
            </div>
            <table class="doc-line-item">
              <tr *ngIf="lilast && item.document?.lineItems?.length > 1" style="height:3em;">
                <td></td><td></td><td></td><td></td><td></td><td></td>
                <td *ngIf="!compilation.hidePricing"><i><label>Sub total net</label>{{getSubTotalNet(item.document) | currency : this.compilation.currency : 'symbol' : '1.2-2' : 'de' }}</i></td>
                <td><i><label>Sub total weight</label>{{getSubTotalWeight(item.document) | number : '1.0-2' : 'de'}}&nbsp;kg</i></td>
              </tr>
            </table>
          </ng-container>

          <div *ngIf="!disabled" class="move-btn-up">
            <div *ngIf="idx == 0" class="moveItemDisabled">▲</div>
            <div *ngIf="idx !== 0" class="moveItem" (click)="onMoveLineItem(idx, true)" title="move up">▲</div>
          </div>
          <div *ngIf="!disabled" class="move-btn-down">
            <div *ngIf="isLast" class="moveItemDisabled">▼</div>
            <div *ngIf="!isLast"class="moveItem" (click)="onMoveLineItem(idx, false)" title="move down">▼</div>
          </div>

      </div>

      <div *ngIf="isLast && compilation.shipmentLineItems.length > 1" class="print-item print-total" style="margin-top:2em;border-top:1px solid lightgray;">
        <table class="doc-line-item" style="border:none;margin:0">
          <tr *ngIf="!compilation.hidePricing">
            <td></td><td></td><td></td><td></td><td></td>
            <td>Total net:</td>
            <td>{{getTotalNet() | currency : this.compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td>&nbsp;</td>
          </tr>
          <tr *ngIf="compilation.hidePricing" style="height:0">
            <td *ngFor="let i of [1,2,3,4,5,6,7,8]" style="height:0;padding:0!important"></td>
          </tr>
          <tr>
            <td></td><td></td><td></td><td></td>
            <td colspan="2">Total weight:</td>
            <td>{{getTotalWeight() | number : '1.0-2' : 'de'}}&nbsp;kg</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td></td><td></td><td></td><td></td>
            <td colspan="2">Total area:</td>
            <td>{{getTotalM2() | number : '1.0-2' : 'de'}}&nbsp;m²</td>
            <td>&nbsp;</td>
          </tr>
         </table>
      </div>
    </div>
  </ng-container>

</div>

<!-- <ngx-document-printer *ngIf="printSPOs"
  #documentPrinter 
  [compilation]="spo" 
  [userOptions]="$any(data.userOptions)"
  [compilationData]="data.compilationData"
  [deliveryConditions]="getSelected($any(spo).deliveryConditions, $any(deliveryConditionOptions))"
  [taxHint]="getSelected(spo.taxHint, $any(taxHintOptions))"
  [relatedDocuments]="$any(relatedDocuments)"
  [latestVersionItems]="data.latestVersionItems"
  (done)="printSPOs=true">
</ngx-document-printer> -->
